import {Controller} from "@hotwired/stimulus";
import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export default class extends Controller {
    static values = {
        slidesPerViewSm: Number,
        slidesPerViewMd: Number
    };

    connect() {
        const slidesPerViewSm = this.slidesPerViewSmValue || 2;
        const slidesPerViewMd = this.slidesPerViewMdValue || 5;


        this.swiper = new Swiper(this.element, {
            modules: [Navigation, Pagination],
            slidesPerView: 5,
            observer: true,
            spaceBetween: 15,
            observeParents: true,
            breakpoints: {
                768: {slidesPerView: slidesPerViewMd},
                300: {slidesPerView: slidesPerViewSm},
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
            navigation: {
                nextEl: ".swiper-button-charity-next",
                prevEl: ".swiper-button-charity-prev",
            },
        });
    }
}